import { CHART_ELEMENT_ID } from 'finviz-charts/app/constants/common'
import * as React from 'react'
import ReactDOM from 'react-dom'

import {
  ChartLayoutWithGlobalState,
  FREE_DATE_RANGES,
  Quote,
  RootChartConfigObject,
  Theme,
} from '../../../../app/charts-lib'
import { decodeQueryString } from '../../../../app/queryString'
import { getInitChartConfig } from '../../../../app/shared/getInitChartConfig'
import { SpecificChartFunctionality, TIMEFRAME } from '../../../constants'
import { initIdeaQuotes } from '../../charts/util'
import { getChartLayoutSizeConfig, useChartLayoutWidthWatch } from '../hooks/use-chart-layout-width-watch'

export function QuoteChart({
  configOverride,
  TAOverride,
}: {
  configOverride?: Partial<RootChartConfigObject>
  TAOverride?: any
}) {
  const chartEl = React.useRef(document.getElementById(CHART_ELEMENT_ID))
  useChartLayoutWidthWatch()

  const config = React.useMemo(() => {
    let chartConfig = window.globalChartConfig

    if (!chartConfig) return

    if (chartConfig.ideaQuotes) {
      // Load idea quote data
      initIdeaQuotes(chartConfig.ideaQuotes, chartConfig)
    } else {
      // Create Quote from inlined data so we don’t have to fetch it
      if (chartConfig.quoteData) Quote.create(chartConfig.quoteData)
      chartConfig = getInitChartConfig(chartConfig, TAOverride)
    }

    const { p = FinvizSettings.defaultPeriod } = decodeQueryString()
    const sizeConfig = getChartLayoutSizeConfig(chartConfig, p as TIMEFRAME)

    return {
      ...chartConfig,
      ...sizeConfig,
      theme: FinvizSettings.hasDarkTheme ? Theme.dark : Theme.light,
      specificChartFunctionality: SpecificChartFunctionality.quotePage,
      charts: chartConfig.charts.map((chart) => ({
        ...chart,
        dateRange:
          FinvizSettings.hasUserPremium || FREE_DATE_RANGES.includes(chart.dateRange ?? '') ? chart.dateRange : null,
      })),
      ...configOverride,
    }
  }, [TAOverride, configOverride])

  if (!config || !chartEl.current) return null

  return ReactDOM.createPortal(<ChartLayoutWithGlobalState parentElement={chartEl} config={config} />, chartEl.current)
}
